import { gql } from '@apollo/client';

export const CompanyInvitationFragment = gql`
  fragment CompanyInvitation on CompanyInvitation {
    id
    email
    scope
    acceptedAt
    companyId
  }
`;
